// extracted by mini-css-extract-plugin
export var active = "_gs-2";
export var recordingDot = "_gs-1";
export var recordingIndicator = "_gs-0";